import type { LucideIcon } from 'lucide-react';
import {
  Activity,
  BookOpen,
  Briefcase,
  Building2,
  Calendar,
  ChartLine,
  CircleHelp,
  FileSignature,
  FileText,
  Files,
  Handshake,
  Laptop,
  LayoutDashboard,
  Mail,
  Receipt,
  Send,
  Settings,
  ShieldCheck,
  User,
  Users,
} from 'lucide-react';
import { menuPermissions } from '@/config/permissions';

/** Same icon set as `Sidebar` menu items (`iconType` from `menuPermissions`). */
export const SIDEBAR_MENU_ICON_MAP: Record<string, LucideIcon> = {
  dashboard: LayoutDashboard,
  missions: Briefcase,
  freelancers: Users,
  activity: Activity,
  clients: Building2,
  company: Building2,
  users: Users,
  reporting: ChartLine,
  handbook: BookOpen,
  devices: Laptop,
  faq: CircleHelp,
  profile: User,
  'file-text': FileText,
  files: Files,
  receipt: Receipt,
  calendar: Calendar,
  'shield-check': ShieldCheck,
  audit: ShieldCheck,
  handshake: Handshake,
  blog: BookOpen,
  'file-signature': FileSignature,
  send: Send,
  mail: Mail,
  settings: Settings,
};

export function getSidebarMenuIcon(iconType: string): LucideIcon {
  return SIDEBAR_MENU_ICON_MAP[iconType] ?? LayoutDashboard;
}

/** Longest prefix match against sidebar `menuPermissions` paths (+ settings / onboarding). */
export function resolveMenuIconTypeForPath(pathWithOptionalQuery: string): string {
  const pathname = pathWithOptionalQuery.split('?')[0] ?? pathWithOptionalQuery;

  let bestPath = '';
  let iconType = 'dashboard';

  for (const item of menuPermissions) {
    for (const path of item.paths) {
      const matches = pathname === path || pathname.startsWith(`${path}/`);
      if (matches && path.length >= bestPath.length) {
        bestPath = path;
        iconType = item.iconType;
      }
    }
  }

  if (bestPath) {
    return iconType;
  }

  if (pathname === '/settings' || pathname.startsWith('/settings/')) {
    return 'settings';
  }

  if (pathname.startsWith('/onboarding')) {
    return 'profile';
  }

  return 'dashboard';
}
